export const ResilientBackendFetch = (cdnUrl) => (tolgee, tools) => {
    tools.addBackend({
        getRecord({ namespace, language, fetch: tolgeFetch }) {
            const path = `${cdnUrl}/${namespace}/${language}.json`;
            return tolgeFetch(path, {
                headers: { Accept: "application/json" },
            })
                .then(r => {
                if (!r.ok) {
                    throw new Error(`${r.url} ${r.status}`);
                }
                return r.json();
            })
                .catch(e => {
                console.warn(`Tolgee: Failed to fetch translations from ${path}`, e);
                return undefined;
            });
        },
    });
    return tolgee;
};
//# sourceMappingURL=resilientBackendFetch.js.map